import { render } from "./App.vue?vue&type=template&id=a0c5a79c"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=a0c5a79c&lang=scss"

import exportComponent from "C:\\wamp64\\www\\suph-annuaire-plugin\\suph-card-pro\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__